import { constructionJobStatusToTaskStatus } from '@euler/app/flows/task/functions';
import { TVNavParams } from '@euler/app/Routes.tv';
import { DetailRow } from '@euler/app/tv/components/detail/DetailRow';
import {
  DetailRowHead,
  DetailRowHeadInfo,
} from '@euler/app/tv/components/detail/DetailRowHead';
import { DetailRowUserView } from '@euler/app/tv/components/detail/DetailRowUserView';
import { InspectionTaskJobStatus } from '@euler/model/enum';
import {
  ConstructionJob,
  taskMediaToMediaObject,
} from '@euler/model/task-detail';
import { timeUtilNow } from '@euler/utils/formatters';
import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import { memo, useCallback, useMemo } from 'react';
import { StyleProp, ViewStyle } from 'react-native';

export const ConstructionJobDetailView = memo(
  ({
    job,
    style,
    onPress,
  }: {
    job: ConstructionJob;
    style?: StyleProp<ViewStyle>;
    onPress?: (job: ConstructionJob) => void;
  }) => {
    const navigation = useNavigation<StackNavigationProp<TVNavParams>>();

    const medias = useMemo(
      () =>
        job.procedures
          .flatMap(x => x.medias)
          .map(x => {
            const media = taskMediaToMediaObject(x);
            media.title = media.subTitle;
            media.subTitle = undefined;
            return media;
          }),
      [job],
    );

    const updatedOrFinishedTime = job.finishedAt ?? job.updatedAt;
    const infoRows = useMemo<DetailRowHeadInfo[]>(
      () => [
        {
          label: '派工时间',
          content: timeUtilNow(job.createdAt, 'M/dd HH:mm'),
        },
        {
          label: job.finishedAt ? '完成时间' : '更新时间',
          content:
            updatedOrFinishedTime != null
              ? timeUtilNow(updatedOrFinishedTime, 'M/dd HH:mm')
              : '-',
        },
      ],
      [job.createdAt, job.finishedAt, updatedOrFinishedTime],
    );
    const statusText =
      job.status === InspectionTaskJobStatus.Pending
        ? '待施工'
        : job.status === InspectionTaskJobStatus.InProgress
        ? '施工中'
        : '已完成';

    const handlePress = useCallback(() => {
      onPress?.(job);
    }, [onPress, job]);

    const onMemberPress = useCallback(() => {
      if (job.technicianId == null) return;
      navigation.navigate('_memberDetail', {
        targetMemberId: job.technicianId,
      });
    }, [job.technicianId, navigation]);

    return (
      <DetailRow medias={medias} style={style} onPress={handlePress}>
        <DetailRowHead
          title={job.name}
          status={constructionJobStatusToTaskStatus(job.status)}
          infoRows={infoRows}
          statusText={statusText}
          onPress={handlePress}
          //titleNumberOfLines={1}
        />
        <DetailRowUserView
          userId={job.technicianId ?? 0}
          name={job.technicianName ?? '未派工'}
          label="施工技师"
          title="一级技师"
          onPress={onMemberPress}
          onPressShade={handlePress}
        />
      </DetailRow>
    );
  },
);
